import { Component, EventEmitter } from '@angular/core';

import type { OfferItem } from '@recruitee/offers-types';

import { OfferTableRowActionsComponent } from '../../offers-page/offers-table/offer-table-row-actions/offer-table-row-actions.component';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
 @angular-eslint/no-outputs-metadata-property,
*/

@Component({
  imports: [OfferTableRowActionsComponent],
  template: `
    <rt-offer-table-row-actions
      [offer]="offer"
      [canPromoteSection]="canPromoteSection"
      [canManageJobs]="canManageJobs"
      [followLoading]="followLoading"
      (toggleFollow)="toggleFollow.emit($event)"
    />
  `,
  inputs: RowActionsCellComponent.NgInputs,
  outputs: RowActionsCellComponent.NgOutputs,
  host: {
    '(click)': '$event.stopImmediatePropagation()',
  },
})
export class RowActionsCellComponent {
  public static NgInputs = [
    'offer' as const,
    'canPromoteSection' as const,
    'canManageJobs' as const,
    'followLoading' as const,
  ];
  public static NgOutputs = ['toggleFollow' as const];

  public offer: OfferItem;
  public followLoading: boolean;
  public canPromoteSection: boolean;
  public canManageJobs: boolean;

  public toggleFollow = new EventEmitter<OfferItem>();
}
